import { CustomizationColors, FlexAlignCenter, IconDispatcher, SwimlaneColors } from "shared/ui-basics";
import styled, { css } from "styled-components";
import { useTranslation } from "react-i18next";

interface ColorPickerVerticalProps {
	variant: "swimlane" | "taxonomy";
	onSelect: ({ e, color }: { e: any; color: string }) => void;
	selectedColor: string;
}

export const ColorPickerVertical: React.FC<ColorPickerVerticalProps> = ({ variant, onSelect, selectedColor }) => {
	const { t } = useTranslation();

	let colorData = [];
	switch (variant) {
		case "taxonomy":
			colorData = Object.keys(CustomizationColors).map((key) => CustomizationColors[key]);
			break;
		default:
			break;
	}

	return (
		<Container>
			{colorData?.map((data, i) => (
				<FlexAlignCenter key={i} gap="16" onClick={(e) => onSelect({ e, color: data?.backgroundColor })}>
					<ColorSquare borderColor={data?.borderColor} backgroundColor={data?.backgroundColor}>
						<Check visible={selectedColor === data.backgroundColor}>{IconDispatcher("CHECK")}</Check>
					</ColorSquare>
					<Description>{t(data?.description)}</Description>
				</FlexAlignCenter>
			))}
		</Container>
	);
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	width: 100%;
`;

const ColorSquare = styled.div<{ backgroundColor: string; borderColor: string }>`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	border-radius: 4px;
	background-color: ${({ backgroundColor }) => backgroundColor};
	border: 1px solid ${({ borderColor }) => borderColor};

	:hover {
		cursor: pointer;
	}
`;

const Check = styled.div<{ visible: boolean }>`
	visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
	path {
		fill: #333;
	}
`;

const Description = styled.div`
	color: #262626;
	font-family: "Inter";
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: 150%;
	:hover {
		cursor: pointer;
	}
`;
